module.exports = __webpack_public_path__ + "files/0f6ad01e67de6324a3a3842ce80dfd86.png";